import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { HardHat, KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Token ausente. Verifique o link do email.");
    if (pw.length < 6) return toast.error("Senha deve ter no mínimo 6 caracteres");
    if (pw !== pw2) return toast.error("As senhas não conferem");
    setLoading(true);
    try {
      await api.post("/auth/password-reset", { token, new_password: pw });
      setDone(true);
      toast.success("Senha redefinida. Você já pode entrar.");
      setTimeout(() => nav("/login", { replace: true }), 2000);
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50 dark:bg-slate-950">
      <Card className="w-full max-w-md rounded-sm shadow-none p-8" data-testid="reset-page">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-sm bg-orange-500 flex items-center justify-center">
            <KeyRound className="w-5 h-5 text-white" />
          </div>
          <div>
            <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-muted-foreground">Recuperação</div>
            <div className="font-heading font-black text-xl leading-tight">Redefinir Senha</div>
          </div>
        </div>

        {done ? (
          <div className="text-center py-6">
            <p className="text-sm text-muted-foreground">Senha alterada. Redirecionando para o login...</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-muted-foreground">Defina uma nova senha para entrar no sistema.</p>
            <div>
              <Label>Nova senha</Label>
              <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="rounded-sm mt-1.5" minLength={6} required data-testid="reset-new-password" />
            </div>
            <div>
              <Label>Confirme a senha</Label>
              <Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="rounded-sm mt-1.5" minLength={6} required data-testid="reset-confirm-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-sm bg-orange-500 hover:bg-orange-600 text-white font-semibold" data-testid="reset-submit">
              {loading ? "Salvando..." : "Redefinir Senha"}
            </Button>
          </form>
        )}
      </Card>
    </div>
  );
}
